import { Container } from '@mui/material';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import { UserForm } from './user-form';
import { UserList } from './user-list';

class Users extends React.Component<RouteComponentProps> {
    public render(): React.ReactNode {
        return (
            <Container maxWidth='md'>
                <Switch>
                    <Route exact path={this.props.match.path}>
                        <UserList />
                    </Route>
                    <Route path={`${this.props.match.path}/:id`}>
                        <UserForm />
                    </Route>
                </Switch>
            </Container>
        );
    }
}

const connected = withRouter(Users);

export { connected as Users };
